import React, { useEffect, useState } from "react";
import "./Nav.css";

const Nav = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                setShow(true);
            } else setShow(false);
        });
        return () => {
            window.removeEventListener("scroll", null);
        };
    }, []);
    return (
        <div className={`nav ${show && "nav_black"}`}>
            <img className="nav_logo" src="https://upload.wikimedia.org/wikipedia/commons/7/7a/Logonetflix.png" alt="Netflix-Logo" />
            <img className="nav_avatar" src="https://i.pinimg.com/564x/55/ba/30/55ba30e8f83d0064ee7669dc203ad1d5.jpg" alt="Netflix-avatar" />
        </div>
    );
};

export default Nav;
